import React, { useEffect, useState } from 'react';
import SimpleTable from 'components/Commun/Table/SimpleTable';
import * as PropTypes from 'prop-types';

const TableauRga = ({ dataRga, isLoading }) => {
    const { numeroRGA, type, marque, modele, canonUn, classementFrancais } = dataRga;

    const [data, setData] = useState([]);
    const header = ['Numéro RGA', 'Type', 'Marque', 'Modèle', 'Calibre', 'Classement'];

    useEffect(() => {
        if (dataRga) {
            setData([numeroRGA, type, marque, modele, canonUn.libelleCalibre, classementFrancais]);
        } else {
            setData([]);
        }
    }, [dataRga]);

    return <SimpleTable isLoading={isLoading} entete={header} donnees={[data]} />;
};

TableauRga.propTypes = {
    isLoading: PropTypes.bool,
    dataRga: PropTypes.shape({
        numeroRGA: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        marque: PropTypes.string.isRequired,
        modele: PropTypes.string.isRequired,
        classementFrancais: PropTypes.string.isRequired,
        canonUn: PropTypes.shape({
            libelleCalibre: PropTypes.string.isRequired,
        }),
    }),
};

TableauRga.defaultProps = {
    dataRga: {
        numeroRGA: '',
        type: '',
        marque: '',
        modele: '',
        classementFrancais: '',
        canonUn: {
            libelleCalibre: '',
        },
    },
    isLoading: false,
};

export default TableauRga;
